import { AlertOutlineIcon } from '@eventbrite/marmalade';
import React from 'react';
import styles from './ContactOrganizer.module.scss';
import ContactOrganizerInfo from './ContactOrganizerInfo/ContactOrganizerInfo';

export interface ContactOrganizerProps {
  infoText: string;
}

const ContactOrganizer: React.FC<ContactOrganizerProps> = ({ infoText }) => {
  return (
    <div>
      <div className={styles['organizer-container']}>
        <AlertOutlineIcon size="xlarge" color="#DDDAE3" />
      </div>
      <ContactOrganizerInfo infoText={infoText} />
    </div>
  );
};

export default ContactOrganizer;
